module.exports = __webpack_public_path__ + "static/img/2.97d56a4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/2/eng/2.png
// module id = n0U9
// module chunks = 0